import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { inject } from '@angular/core';
import { RouteEnum } from '../../enums/routes.enum';
import { UserService } from '../../services/user/user.service';
import { ProjectService } from '../../services/project/project.service';
import { PermissionsEnum } from '../../enums/permissions.enum';
import { ConfigService } from '../../services/config/config.service';
import { StatusEnum } from '../../enums/status.enum';

export const authGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	const userService = inject(UserService);
	const projectService = inject(ProjectService);
	const configService = inject(ConfigService);

	if (!!configService.getConfig()?.maintenanceMode?.active) {
		router.navigateByUrl('/maintenance');
		return false;
	}

	const onlyLoggedOut = route.data?.['onlyLoggedOut'] ?? true;
	const onDenialRoute = route.data?.['onDenialRoute'] ?? RouteEnum.LOGIN;
	const isLoggedIn = await authService.isAuth();
	const username = route.queryParamMap.get('username');
	const password = route.queryParamMap.get('password');
	const alreadyLoggedOut = route.queryParamMap.get('logout') === 'true';

	if (state?.url === '/' && projectService.hasPermissions(PermissionsEnum.VIEW_HOME)) {
		router.navigateByUrl(RouteEnum.HOME);
		return false;
	}

	if (state?.url?.startsWith(`/${RouteEnum.LOGIN}`) && (username && password) && !alreadyLoggedOut) {
		await authService.logout();
		router.navigate([RouteEnum.LOGIN], {
			queryParams: {
				username,
				password,
				logout: true
			},
			replaceUrl: true
		});
		return false;
	}

	// TODO: change this later — allow deactivated (status=1) users to enter
	// if (isLoggedIn && authService?.auth?.user?.status === StatusEnum.INACTIVE) {
	// 	await authService.logout();
	// 	return false;
	// }

	if (isLoggedIn && state?.url === '/') {
		const roleRoute = userService.getRoute(authService.auth?.user?.role);

		if (state?.url !== roleRoute) {
			router.navigateByUrl(roleRoute);
			return false;
		}
	}

	if (isLoggedIn && onlyLoggedOut) {
		const roleRoute = userService.getRoute(authService.auth?.user?.role);
		router.navigateByUrl(roleRoute);
		return false;
	}

	if (!isLoggedIn && !onlyLoggedOut) {
		authService.setUrlAfterLogin(state?.url);
		router.navigateByUrl(onDenialRoute);
		return false;
	}

	return true;
};

